// Generated by ts-to-zod
import { z } from 'zod'

import { BLOCK_TYPE } from '../../../types/next/enums'

import { DEVICE_OPTION_FACTOR_PRESET } from './../../../types/next/blocks/inputCalculatorBlock'
import { iBlockSchema, blockBaseSettingsSchema } from './baseBlock.zod'
import { sortableSchema, universallyUniqueIdSchema } from './common.zod'
import { unitsSchema } from './enums.zod'

export const deviceOptionFactorCustomMappingsSchema = z.object({
  multiplicationFactor: z.number().optional(),
  quantity: z.number(),
  unitaryDemand: z.number().optional()
})

export const deviceOptionFactorPresetSchema = z.nativeEnum(
  DEVICE_OPTION_FACTOR_PRESET
)

export const iDeviceFactorSchema = z.object({
  preset: deviceOptionFactorPresetSchema,
  customMappings: z
    .union([z.never(), z.array(deviceOptionFactorCustomMappingsSchema)])
    .optional()
})

export const deviceOptionFactorSchema = iDeviceFactorSchema.extend({
  preset: z.union([
    z.literal(DEVICE_OPTION_FACTOR_PRESET.GAS),
    z.literal(DEVICE_OPTION_FACTOR_PRESET.POWER),
    z.literal(DEVICE_OPTION_FACTOR_PRESET.WATER_HEATER)
  ]),
  customMappings: z.never().optional()
})

export const deviceOptionCustomFactorSchema = iDeviceFactorSchema.extend({
  preset: z.literal(DEVICE_OPTION_FACTOR_PRESET.CUSTOM),
  customMappings: z.array(deviceOptionFactorCustomMappingsSchema)
})

export const inputCalculatorItemSchema = sortableSchema.extend({
  id: z.string(),
  preSelect: z.boolean(),
  name: z.string(),
  factor: z
    .union([deviceOptionFactorSchema, deviceOptionCustomFactorSchema])
    .optional()
})

export const inputCalculatorItemIdSchema = universallyUniqueIdSchema

export const inputCalculatorBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.INPUT_CALCULATOR),
  required: z.literal(false),
  settings: blockBaseSettingsSchema.and(
    z.object({
      allowOther: z.boolean(),
      items: z.record(inputCalculatorItemIdSchema, inputCalculatorItemSchema),
      deviceUnit: unitsSchema,
      digitsAfterDecimalPoint: z.number()
    })
  )
})

export const inputCalculatorDeviceValueSchema = z.object({
  name: z.string().nullable(),
  otherName: z.string().optional().nullable(),
  quantity: z.string(),
  unitaryConsumption: z.string(),
  consumption: z.string().optional()
})

export const inputCalculatorValueSchema = z.object({
  numberInput: z.string().optional().nullable(),
  numberUnit: z.string().optional(),
  frequencyUnit: z.string().optional(),
  devices: z.array(inputCalculatorDeviceValueSchema).optional()
})
